import qs from 'qs';

import { Paths } from '@/pages/routers';
import env from '@/env';
import identityApiClient from './identity-api-client';
import tokenApiClient from './token-api-client';

class AuthService {
  getAppAccessToken = async (): Promise<string> => {
    const body = qs.stringify({ grant_type: 'client_credentials', scope: 'PRODUCTION' });
    const response = await tokenApiClient.post('', body);
    return response.data.access_token;
  };

  refreshToken = async (refreshToken: string) => {
    const body = qs.stringify({ grant_type: 'refresh_token', refresh_token: refreshToken });
    const response = await tokenApiClient.post('', body);
    return response.data;
  };

  registerWithEmail = async (emailAddress: string, firstName: string, lastName: string, password: string) => {
    const body = {
      emailAddress,
      firstName,
      lastName,
      password,
      callbackUrl: `${env.rootUrl}/auth/login?redirect=${Paths.Auth}${Paths.BankDetail}`,
    };
    const response = await identityApiClient.post('users', body);
    return response.data;
  };

  registerWithInviteCode = async (inviteCode: string, password: string) => {
    const body = {
      inviteCode,
      password,
      callbackUrl: `${env.rootUrl}${Paths.Auth}${Paths.Login}`,
    };
    const response = await identityApiClient.post('users', body);
    return response.data;
  };

  signInWithEmail = async (email: string, password: string) => {
    const body = qs.stringify({
      grant_type: 'password',
      username: email,
      password,
    });
    const response = await tokenApiClient.post('', body, {
      params: {
        scope: 'openid',
      },
    });
    return response.data;
  };

  getPasswordRecoveryOptions = async (identifier: string) => {
    const response = await identityApiClient.get(`users/${encodeURIComponent(identifier)}/recovery-options`);
    return response.data;
  };

  initializePasswordRecovery = async (channelId: string, recoveryCode: string) => {
    const body = {
      channelId,
      recoveryCode,
    };
    const response = await identityApiClient.post('users/passwords/reset-request', body);
    return response.data;
  };

  activateAccount = async (activateToken: string, code: string) => {
    const body = { verificationCode: code };
    const response = await identityApiClient.put(`users/verifications/${activateToken}`, body);
    return response.data;
  };

  resetPassword = async (code: string, password: string) => {
    const body = {
      password,
    };

    const response = await identityApiClient.put(`users/passwords/reset-requests/${code}`, body);
    return response.data;
  };
}

const instance = new AuthService();
export default instance;
export { default as authHelpers } from './helpers';
